import { StyleSheet, View } from 'react-native';

import { Typography } from 'components/ui';
import { useFormatCalories } from 'hooks/use-format-calories';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { useUIContext } from 'state/ui';
import { ILocalizedMenuEntry } from 'state/unified-menu/types';
import { useMenuQueryOptions } from 'state/unified-menu/use-menu-query-options';

type CatalogPriceCaloriesProps = {
  product: ILocalizedMenuEntry;
};

/** Catalog price and calories for the no-store product preview. */
export function CatalogPriceCalories({ product }: CatalogPriceCaloriesProps) {
  const isDesktop = useIsDesktopBreakpoint();
  const { formatCurrencyForLocale } = useUIContext();
  const { posServiceMode } = useMenuQueryOptions();
  const formatCalories = useFormatCalories();

  const amount = product.price?.[posServiceMode];
  const formattedPrice =
    typeof amount === 'number' && amount > 0 ? formatCurrencyForLocale(amount) : '';
  const calorieValue = product.nutrition?.calories?.def;
  const calories = typeof calorieValue === 'number' ? formatCalories(calorieValue) : '';

  if (!formattedPrice && !calories) {
    return null;
  }

  const fontStyles = isDesktop ? styles.desktop : styles.mobile;
  const accessibilityLabel = [formattedPrice, calories].filter(Boolean).join(' ');

  return (
    <View accessibilityLabel={accessibilityLabel} style={styles.row}>
      {formattedPrice ? (
        <Typography testID="product-total-price" style={fontStyles}>
          {formattedPrice}
        </Typography>
      ) : null}
      {formattedPrice && calories ? <Typography style={fontStyles}>{'  |  '}</Typography> : null}
      {calories ? (
        <Typography testID="product-total-calories" style={fontStyles}>
          {calories}
        </Typography>
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  desktop: {
    fontSize: 24,
  },
  mobile: {
    fontSize: 18,
  },
  row: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
    marginBottom: 12,
    width: '100%',
  },
});
